import * as React from 'react';
import { Component } from 'react';
import { EditorState, Modifier } from 'draft-js';

class VariableSelectButtonComponent extends Component {

    constructor(props) {
        super(props)
        this.state = {
            open: false
        }
    }

    openVariableDropdown = currentTarget => {
        currentTarget.focus()
        // @ts-ignore
        this.setState({ open: !this.state.open })
    }

    closeVariableDropdown = () => this.setState({ open: false })

    addVariable = (variable) => {
        // @ts-ignore
        const { editorState, onChange } = this.props;
        const contentState = Modifier.replaceText(
            editorState.getCurrentContent(),
            editorState.getSelection(),
            variable,
            editorState.getCurrentInlineStyle(),
        )
        onChange(EditorState.push(editorState, contentState, 'insert-characters'))
    }


    render() {
        // @ts-ignore
        let { variables, disabled } = this.props
        return (
            <div className="rdw-block-wrapper" aria-label="rdw-block-control">
                <div onClick={e => this.openVariableDropdown(e.currentTarget)} onBlur={this.closeVariableDropdown} tabIndex={-1} className="rdw-dropdown-wrapper rdw-block-dropdown calcpad-rte-option" aria-label="rdw-dropdown">
                    <div className={disabled ? "rdw-dropdown-selectedtext calcpad-rte-disabled" : "rdw-dropdown-selectedtext"} title="VariableSelectButtonComponent" aria-expanded="false">
                        <span>Variables</span>
                        {/* @ts-ignore */}
                        <div className={this.state.open ? "rdw-dropdown-carettoclose" : "rdw-dropdown-carettoopen"}></div>
                    </div>
                    {/* @ts-ignore */}
                    <ul className={this.state.open ? "rdw-dropdown-optionwrapper calcpad-rte-dropdown" : "rdw-dropdown-optionwrapper calcpad-rte-dropdown variable-ul"}>
                        {/* @ts-ignore */}
                        {variables.map(variable => (
                            <li
                                key={variable.name}
                                className={disabled ? "rdw-dropdownoption-default variable-li calcpad-rte-disabled" : "rdw-dropdownoption-default variable-li"} onClick={this.addVariable.bind(this, "[" + variable.name + "]")}>
                                {variable.name}
                            </li>
                        ))}
                        <li className={disabled ? "rdw-dropdownoption-default variable-li calcpad-rte-disabled" : "rdw-dropdownoption-default variable-li"} onClick={this.addVariable.bind(this, "[g]")}>
                            g
                        </li>
                    </ul>
                </div>
            </div>
        );
    }
}

export default VariableSelectButtonComponent
